import React from "react";
import { useLocation } from "react-router-dom";
import { Phone, AlertTriangle, ShieldCheck, ExternalLink } from "lucide-react";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { SEO, breadcrumbSchema } from "../components/SEO";

const CONTENT = {
    "/mentions-legales": {
        title: "Mentions légales",
        sections: [
            {
                h: "Éditeur du site",
                p: "Pronospot.com est édité par Monsieur LAMCHACHTI MOHAMED.",
            },
            {
                h: "Directeur de la publication",
                p: "Le directeur de la publication est Monsieur LAMCHACHTI MOHAMED.",
            },
            {
                h: "Hébergeur",
                p: "Le site est hébergé par Hostinger International Ltd., situé à 61 Lordou Vironos Street, 6023 Larnaca, Chypre.",
            },
            {
                h: "Propriété intellectuelle",
                p: "L'ensemble des contenus présents sur Pronospot.com (textes, images, logos) est protégé par le droit d'auteur. Toute reproduction sans autorisation est interdite.",
            },
            {
                h: "Indépendance",
                p: "Pronospot.com est un comparateur de cotes et d'offres de paris sportifs indépendant. Nous pouvons afficher des liens d'affiliation partenaires, mais nous ne percevons aucune commission directe sur vos mises ou vos pertes, garantissant une indépendance éditoriale totale.",
            },
            {
                h: "Limitation de responsabilité",
                p: "Les cotes et informations de paris sportifs affichées sur Pronospot.com sont fournies à titre purement indicatif et sont sujettes à des fluctuations en temps réel de la part des opérateurs de jeux. Nous ne saurions être tenus responsables de toute différence constatée au moment de la validation de vos paris chez le bookmaker.",
            },
            {
                h: "Droit applicable et juridiction",
                p: "Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut de résolution amiable, les tribunaux français seront seuls compétents.",
            },
        ],
    },
    "/politique-confidentialite": {
        title: "Politique de confidentialité",
        sections: [
            {
                h: "Données collectées",
                p: "Nous collectons uniquement les données nécessaires au fonctionnement du site : adresse IP anonymisée, cookies analytiques (avec consentement), et email lors d'une inscription à la newsletter.",
            },
            {
                h: "Cookies",
                p: "Notre site utilise des cookies techniques et analytiques conformément au RGPD. Vous pouvez accepter ou refuser via la bannière de consentement.",
            },
            {
                h: "Vos droits",
                p: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Contactez-nous à contact@pronospot.com pour toute demande.",
            },
            {
                h: "Conservation",
                p: "Les données analytiques sont conservées 13 mois maximum. Les emails newsletter sont supprimés sur simple demande.",
            },
        ],
    },
    "/jeu-responsable": {
        title: "Jeu responsable",
        sections: [
            {
                h: "Notre engagement",
                p: "Pronospot.com s'engage à promouvoir le jeu responsable. Les paris sportifs doivent rester un divertissement, jamais une source de revenus ou de stress.",
            },
            {
                h: "Signes d'alerte",
                p: "Si vous misez plus que prévu, jouez pour 'vous refaire', mentez à vos proches sur votre activité de paris, ou ressentez de l'anxiété : ce sont des signes d'alerte. N'hésitez pas à demander de l'aide.",
            },
            {
                h: "Outils d'auto-exclusion",
                p: "Tous les opérateurs agréés ANJ proposent des outils de limitation : plafonds de dépôt, limites de mise, auto-exclusion temporaire ou définitive. Activez-les dans votre espace personnel.",
            },
            {
                h: "Ressources d'aide",
                p: "Joueurs Info Service (anonyme et gratuit) : 09 74 75 13 13 — disponible 8h-2h, 7j/7. Site : joueurs-info-service.fr",
            },
        ],
        contact: true,
    },
    "/politique-cookies": {
        title: "Politique des Cookies",
        sections: [
            {
                h: "Introduction",
                p: "La présente politique de cookies a pour but de vous informer de manière claire et transparente sur la manière dont nous utilisons les cookies et autres traceurs sur le site Pronospot.com. Lors de votre première visite sur notre site, un bandeau d'information vous permet d'accepter, de refuser ou de configurer vos choix concernant le dépôt de cookies non essentiels sur votre terminal.",
            },
            {
                h: "1. Qu'est-ce qu'un cookie ?",
                p: "Un cookie est un petit fichier texte contenant un identifiant unique (une chaîne de lettres et de chiffres). Il est stocké sur votre terminal (ordinateur, smartphone ou tablette) par votre navigateur internet lorsque vous visitez un site web. Les cookies sont couramment utilisés pour faire fonctionner les sites, améliorer l'expérience de navigation et fournir des informations statistiques et marketing aux propriétaires de sites. Les informations collectées par nos cookies ne permettent pas de vous identifier directement par votre nom ou votre prénom. Toutefois, certaines données de navigation (comme votre adresse IP) peuvent être qualifiées de données personnelles au sens du RGPD lorsqu'elles sont croisées avec des identifiants techniques.",
            },
            {
                h: "2. Quels types de cookies utilisons-nous sur Pronospot.com ?",
                p: (
                    <span>
                        Nous utilisons deux grandes catégories de cookies sur notre site :
                        <br /><br />
                        <strong>A. Cookies analytiques et de mesure d'audience (Tiers)</strong>
                        <br />
                        Nous utilisons ces cookies pour comprendre la manière dont nos visiteurs naviguent sur le site, analyser les performances de nos pages et savoir quels contenus (pronostics, comparateurs, actualités) retiennent le plus l'attention. Cela nous permet d'adapter l'expérience et de proposer des contenus plus pertinents.
                        <br /><br />
                        Pour cela, nous nous appuyons sur le service tiers <strong>Google Analytics</strong> :
                        <br />
                        - <em>Fonctionnement</em> : Google Analytics recueille des statistiques sur le trafic du site (nombre de visites, provenance géographique, temps passé sur les pages, etc.) de manière globale.
                        <br />
                        - <em>Durée de conservation</em> : Conformément à la réglementation et aux paramètres du service, ces données de navigation sont automatiquement supprimées après une durée de 24 mois suivant leur collecte.
                        <br />
                        - <em>En savoir plus</em> : Vous pouvez consulter les <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#00C853] hover:underline">Règles de confidentialité de Google</a> et leurs <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="text-[#00C853] hover:underline">Conditions d'utilisation</a>.
                        <br /><br />
                        <strong>B. Liens de redirection (Partenaires)</strong>
                        <br />
                        Pronospot.com propose des liens et des outils de comparaison de cotes redirigeant vers des opérateurs de paris sportifs agréés (bookmakers).
                        Lorsque vous cliquez sur l'une de ces cotes ou liens pour visiter un site partenaire, un cookie tiers peut être déposé par l'opérateur concerné à des fins de redirection ou de statistiques. Ces cookies n'ont aucune influence sur les cotes ou les offres promotionnelles qui vous sont proposées.
                        <br />
                        - <em>Consentement</em> : Le dépôt de ces cookies s'effectue au moment de votre clic et dépend également du consentement que vous attribuez sur notre plateforme ou sur celle du partenaire final.
                    </span>
                ),
            },
            {
                h: "3. Comment gérer et contrôler vos choix ?",
                p: (
                    <span>
                        Conformément à la réglementation, aucun cookie non essentiel (analytique ou publicitaire) n'est déposé sur votre appareil sans votre accord préalable.
                        <br /><br />
                        <strong>Le module de gestion du site (CMP)</strong>
                        <br />
                        Vous pouvez modifier vos choix, retirer votre consentement ou accepter les cookies à tout moment en cliquant sur le lien "Gestion des cookies" accessible de manière permanente en bas de chaque page du site Pronospot.com.
                        <br /><br />
                        <strong>La configuration de votre navigateur internet</strong>
                        <br />
                        Vous pouvez également configurer votre navigateur pour qu'il rejette globalement ou partiellement le dépôt de cookies, ou qu'il supprime les cookies déjà installés. Attention, la désactivation totale des cookies peut altérer certaines fonctionnalités de votre navigation internet.
                        <br /><br />
                        Pour personnaliser les paramètres de votre navigateur, vous pouvez consulter les guides d'aide officiels :
                        <br />
                        - <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#00C853] hover:underline">Google Chrome : Lien d'aide officiel</a>
                        <br />
                        - <a href="https://support.mozilla.org/fr/kb/autoriser-bloquer-cookies" target="_blank" rel="noopener noreferrer" className="text-[#00C853] hover:underline">Mozilla Firefox : Lien d'aide officiel</a>
                        <br />
                        - <a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#00C853] hover:underline">Apple Safari : Lien d'aide officiel</a>
                        <br />
                        - <a href="https://support.microsoft.com/fr-fr/windows/g%C3%A9rer-les-cookies-dans-microsoft-edge-1087f9a1-c072-4c8d-96e9-94f7072a2840" target="_blank" rel="noopener noreferrer" className="text-[#00C853] hover:underline">Microsoft Edge : Lien d'aide officiel</a>
                        <br /><br />
                        Pour toute question relative à notre utilisation des cookies ou à la protection de vos données personnelles, vous pouvez nous contacter directement via notre formulaire de contact ou à l'adresse e-mail dédiée de notre site.
                    </span>
                ),
            },
        ],
    },
    "/politique-editoriale": {
        title: "Politique éditoriale",
        sections: [
            {
                h: "Notre engagement éditorial",
                p: "Pronospot.com s'engage à fournir à ses utilisateurs des comparatifs de bookmakers et des analyses de paris sportifs d'une rigueur, d'une impartialité et d'une transparence totales. Notre mission est de guider les parieurs de façon objective.",
            },
            {
                h: "1. Indépendance et Objectivité",
                p: "Pronospot.com est un comparateur indépendant. Bien que nous puissions afficher des liens d'affiliation vers certains opérateurs partenaires, nous ne recevons aucune commission directe sur vos mises ou vos pertes, et nos notations restent basées sur une grille de critères objectifs et neutres.",
            },
            {
                h: "2. Méthodologie d'Évaluation",
                p: "Chaque bookmaker est évalué selon des critères précis et documentés : le niveau des cotes (sur la base d'études comparatives tierces comme Odoxa), la diversité et le nombre de marchés de paris proposés, l'ergonomie et la rapidité de l'application mobile, l'efficacité du service client et la sécurité des transactions bancaires.",
            },
            {
                h: "3. Fiabilité des informations",
                p: "Nous vérifions et mettons à jour quotidiennement les bonus de bienvenue, les cotes, ainsi que les conditions d'utilisation des bookmakers partenaires afin d'offrir des informations fiables à tout instant.",
            },
            {
                h: "4. Auteurs et Respect de la Régulation",
                p: "Nos pronostics et guides sont rédigés par des rédacteurs experts des paris sportifs. Nous veillons scrupuleusement au respect de la législation française fixée par l'ANJ (Autorité Nationale des Jeux) et nous engageons activement pour la prévention du jeu excessif.",
            },
        ],
    },
};

const Legal = () => {
    const { pathname } = useLocation();
    const data = CONTENT[pathname] || CONTENT["/mentions-legales"];

    return (
        <div data-testid="legal-page">
            <SEO
                title={`${data.title} | Pronospot.com`}
                description={`Consultez la page ${data.title} de Pronospot.com. Informations légales et conseils d'utilisation.`}
                jsonLd={breadcrumbSchema([
                    { name: "Accueil", url: "https://pronospot.com/" },
                    { name: data.title, url: `https://pronospot.com${pathname}` },
                ])}
            />
            <section className="container-x pt-10 pb-6">
                <Breadcrumbs items={[{ label: data.title }]} />
                <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white tracking-tighter">
                    {data.title}
                </h1>
            </section>

            <section className="container-x pb-20">
                <div className="max-w-3xl space-y-8">
                    {data.sections.map((s, i) => (
                        <div key={i}>
                            <h2 className="font-heading text-xl font-bold text-white mb-3">
                                {s.h}
                            </h2>
                            <p className="text-gray-300 leading-relaxed">
                                {s.p}
                            </p>
                        </div>
                    ))}

                    {data.contact && (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-10">
                            <div className="card-elev p-6">
                                <Phone
                                    className="text-[#00C853] mb-3"
                                    size={26}
                                />
                                <h3 className="font-heading font-bold text-white mb-2">
                                    Joueurs Info Service
                                </h3>
                                <a
                                    href="tel:0974751313"
                                    className="text-[#00C853] font-heading font-bold text-2xl"
                                >
                                    09 74 75 13 13
                                </a>
                                <p className="text-xs text-gray-400 mt-2">
                                    Anonyme et gratuit · 8h-2h, 7j/7
                                </p>
                            </div>
                            <div className="card-elev p-6">
                                <ShieldCheck
                                    className="text-[#00C853] mb-3"
                                    size={26}
                                />
                                <h3 className="font-heading font-bold text-white mb-2">
                                    Auto-exclusion ANJ
                                </h3>
                                <p className="text-sm text-gray-300 mb-3">
                                    Demande d'interdiction de jeu auprès de
                                    tous les opérateurs agréés.
                                </p>
                                <a
                                    href="https://www.anj.fr"
                                    target="_blank"
                                    rel="noopener nofollow"
                                    className="text-[#00C853] text-sm font-semibold inline-flex items-center gap-1"
                                >
                                    anj.fr
                                    <ExternalLink size={12} />
                                </a>
                            </div>
                        </div>
                    )}

                    <div className="card-elev p-5 border-l-4 border-l-[#FFB300] mt-10 flex gap-3">
                        <AlertTriangle
                            className="text-[#FFB300] flex-shrink-0 mt-1"
                            size={20}
                        />
                        <p className="text-sm text-gray-300">
                            <strong className="text-white">
                                Interdit aux moins de 18 ans.
                            </strong>{" "}
                            Jouer comporte des risques : endettement,
                            isolement, dépendance. Pour être aidé, appelez le
                            09 74 75 13 13 (appel non surtaxé).
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Legal;
